import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';
import { manageDuesPaymentsKeys } from './manage/keys';

const duesPaymentsKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'duesPayments'] as const;
  return createQueryKey({
    all: [...key] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...key, itemId] as const,
      }),
    manage: manageDuesPaymentsKeys([...keys, 'duesPayments'] as const),
  });
};

export { duesPaymentsKeys };
